import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Routes } from '../../../shared/enums';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: true,
    imports: [RouterLinkActive, TranslateModule, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent {
    navigate = output<Routes>();

    links: { label: string; route: Routes }[] = [
        { label: 'PTC.MENU.START', route: Routes.Start },
        { label: 'PTC.MENU.QUESTION_FLOW_EDITOR', route: Routes.QuestionFlowEditor },
        { label: 'PTC.MENU.QUESTION_FLOW_TESTER', route: Routes.QuestionFlowTester },
        { label: 'PTC.MENU.UI_COMPONENTS', route: Routes.UIComponents }
    ];
}
